/* eslint-disable react/prop-types */
/* eslint-disable prettier/prettier */
/* eslint-disable arrow-parens */
import React, { useCallback } from "react";
import { FormControl, InputAdornment, ThemeProvider, createTheme } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import Grid from "@material-ui/core/Grid";
import DateFnsUtils from "@date-io/date-fns";
import "date-fns";
import { ThemeCustomInputField } from "../../../../shared/themeComponents/themeCustomInputField";

import { FiUser, FiHash } from "react-icons/fi";
import EventIcon from "@material-ui/icons/Event";

import "./personalDetails.scss";
import { PersonalDetailsSignUpProps } from "../../../../../@types/components/signupV2.types";

// eslint-disable-next-line arrow-parens
const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
		padding: 5
	},
	paper: {
		color: theme.palette.text.secondary,
		display: "flex",
		flexDirection: "column"
	}
}));

// custom styling for MUI Date Picker
const useDatePickerStyle = makeStyles({
	root: {
		"& .MuiInputBase-root": {
			backgroundColor: "#F2F2F2",
			borderRadius: "5px",
			fontSize: "16px",
			width: "100%",
			height: "50px",

			"&:focus": {
				border: "1px solid #80bdff",
				boxShadow: "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
			}
		},
		"& .MuiOutlinedInput-root": {
			"& fieldset": {
				border: "none" // Removes the border when not focused
			},
			"&.Mui-focused fieldset": {
				border: "1px solid #8C68E1" // Removes the border when focused
			}
		}
	}
});

const scrollResponsiveHandleClick = () => {
	const container = document.getElementById("personal-details-main-container") as HTMLDivElement;
	container.scrollTo({
		top: container.scrollTop + 200,
		behavior: "smooth"
	});
};

const PersonalDetails = ({
	user,
	setUser,
	handleChange,
	handleReEnteredSSNChange,
	handleSubmit,
	handleDateChange,
	validation,
	reEnterSSN,
	reEnterSSNValidation,
	setReEnterSSN,
	setPasted
}: PersonalDetailsSignUpProps) => {
	const classes = useStyles();
	const customStyle = useDatePickerStyle();
	// console.log("re enter ssn", validation.reEnterSSN);
	const handleKeyCheck = useCallback(
		(event: React.KeyboardEvent<HTMLInputElement | HTMLDivElement>) => {
			let { value } = event.target as HTMLInputElement;
			const { name } = event.target as HTMLInputElement;
			const keyID = event.keyCode;

			// console.log("re-enter SSN field", name, value);

			if (name === "SSN") {
				if (keyID === 8 || keyID === 46) {
					if (/[-]/.test(value) && value.length === 4) {
						const index = value.indexOf("-");
						value = value.substring(0, index);
						setUser(Object.assign({}, user, { [name]: value }));
					}
					if (/[-]/.test(value) && value.length === 7) {
						const index = value.lastIndexOf("-");
						value = value.substr(0, index);
						setUser(Object.assign({}, user, { [name]: value }));
					}
				}
			} else if (name === "reEnterSSN") {
				if (keyID === 8 || keyID === 46) {
					if (/[-]/.test(value) && value.length === 4) {
						const index = value.indexOf("-");
						value = value.substr(0, index);
						setReEnterSSN(value);
					}
					if (/[-]/.test(value) && value.length === 7) {
						const index = value.lastIndexOf("-");
						value = value.substr(0, index);
						setReEnterSSN(value);
					}
				}
			}
		},
		[setReEnterSSN, setUser, user]
	);

	const handlePaste = (event: any) => {
		const { name } = event.target;
		if (name === "SSN") {
			setPasted(true);
			setTimeout(() => null, 2000);
		}
	};

	return (
		<div className="personal-details-main-container" id="personal-details-main-container">
			<form onSubmit={handleSubmit} autoComplete="off" method="">
				<FormControl className="form-container" id="form-container">
					<div className={classes.root}>
						<Grid container spacing={2} className="grid-main-container">
							<Grid item xs={6} className="grid-elements">
								<div className={classes.paper}>
									<span className="form-input-label">First Name</span>
									<ThemeCustomInputField
										className="form-field-input"
										style={{ width: "100%", borderRadius: 5, padding: 0, fontSize: 5 }}
										label=""
										name="first_name"
										variant="outlined"
										value={user.first_name}
										placeholder="Enter your firstname"
										helperText={validation.first_name}
										onChange={handleChange}
										InputProps={{
											endAdornment: (
												<InputAdornment position="start">
													<FiUser style={{ color: "#a06cd5", fontSize: 20 }} />
												</InputAdornment>
											)
										}}
									/>
								</div>
							</Grid>
							<Grid item xs={6} className="grid-elements">
								<div className={classes.paper}>
									<span className="form-input-label">Middle Name</span>
									<ThemeCustomInputField
										className="form-field-input"
										style={{ width: "100%", borderRadius: 5, padding: 0, fontSize: 5 }}
										label=""
										name="middle_name"
										variant="outlined"
										value={user.middle_name}
										placeholder="Enter your Middlename"
										helperText={validation.middle_name}
										onChange={handleChange}
										InputProps={{
											endAdornment: (
												<InputAdornment position="start">
													<FiUser style={{ color: "#a06cd5", fontSize: 20 }} />
												</InputAdornment>
											)
										}}
									/>
								</div>
							</Grid>
							<Grid item xs={6} className="grid-elements">
								<div className={classes.paper}>
									<span className="form-input-label">Last Name</span>
									<ThemeCustomInputField
										className="form-field-input"
										style={{ width: "100%", borderRadius: 5, padding: 0, fontSize: 5 }}
										label=""
										name="last_name"
										variant="outlined"
										value={user.last_name}
										placeholder="Enter your lastname"
										helperText={validation.last_name}
										onChange={handleChange}
										onFocus={scrollResponsiveHandleClick}
										InputProps={{
											endAdornment: (
												<InputAdornment position="start">
													<FiUser style={{ color: "#a06cd5", fontSize: 20 }} />
												</InputAdornment>
											)
										}}
									/>
								</div>
							</Grid>
							<Grid item xs={6} className="grid-elements">
								<div className={classes.paper}>
									<span className="form-input-label">Date of Birth</span>
									<div className="form-field-input">
										<MuiPickersUtilsProvider utils={DateFnsUtils}>
											<KeyboardDatePicker
												className={customStyle.root}
												inputVariant="outlined"
												placeholder="Enter Date of Birth"
												id="date-of-birth-input"
												name="date_of_birth"
												format="MM/dd/yyyy"
												error={false}
												value={user.date_of_birth}
												onChange={handleDateChange}
												InputProps={{
													readOnly: true
												}}
												InputLabelProps={{
													shrink: true
												}}
												style={{ width: "100%", borderRadius: 50 }}
												keyboardIcon={<EventIcon style={{ color: "#a06cd5" }} />}
												KeyboardButtonProps={{
													"aria-label": "change date"
												}}
												helperText={validation.date_of_birth}
												openTo="year" // Starts with the year view
												views={["year", "month", "date"]}
											/>
										</MuiPickersUtilsProvider>
									</div>
								</div>
							</Grid>
							<Grid item xs={6} className="grid-elements">
								<div className={classes.paper}>
									<span className="form-input-label">SSN / ALT-ID</span>
									<ThemeCustomInputField
										className="form-field-input"
										style={{ width: "100%", borderRadius: 5, padding: 0, fontSize: 5 }}
										label=""
										name="SSN"
										type="text"
										variant="outlined"
										value={user.SSN}
										placeholder="Enter your SSN / ALT-ID"
										helperText={validation.SSN}
										onChange={handleChange}
										onKeyDown={(event) => handleKeyCheck(event)}
										onPaste={(event) => handlePaste(event)}
										onFocus={scrollResponsiveHandleClick}
										InputProps={{
											endAdornment: (
												<InputAdornment position="start">
													<FiHash style={{ color: "#a06cd5", fontSize: 20 }} />
												</InputAdornment>
											)
										}}
									/>
								</div>
							</Grid>
							<Grid item xs={6} className="grid-elements">
								<div className={classes.paper}>
									<span className="form-input-label">Confirm SSN / ALT-ID</span>
									<ThemeCustomInputField
										className="form-field-input"
										style={{ width: "100%", borderRadius: 5, padding: 0, fontSize: 5 }}
										label=""
										name="reEnterSSN"
										value={reEnterSSN}
										variant="outlined"
										placeholder="Re-enter the SSN / ALT-ID"
										helperText={reEnterSSNValidation}
										onChange={handleReEnteredSSNChange}
										onKeyDown={(event) => handleKeyCheck(event)}
										onPaste={(event) => handlePaste(event)}
										InputProps={{
											endAdornment: (
												<InputAdornment position="start">
													<FiHash style={{ color: "#a06cd5", fontSize: 20 }} />
												</InputAdornment>
											)
										}}
									/>
								</div>
							</Grid>
						</Grid>
					</div>
				</FormControl>
			</form>
		</div>
	);
};

export default PersonalDetails;
